import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { Modal } from 'containers/misc'
import { EmailSend } from 'containers/forms/emails'
import { LeaderTransferParticipants } from 'containers/forms/leaders'
import { ContactRemove, ContactSettings } from 'containers/forms/contacts'
import { Module, FormData, Status, Button, ModuleLink } from 'components/misc'
import { apiPersons } from 'helpers/decorators/api'
import { REMOVE_CONTACT_TYPES, ROLES } from 'constants/enums'
import { getActiveRole } from 'utils/token'
import { permissions } from 'helpers/decorators'
import config from 'config'

@connect(({ auth }) => ({
  activeOrganization: auth.organization
}))
@apiPersons({
  leaderReadParams: 'AWARD_LEADERSHIP_HISTORY,TRAININGS'
})
@permissions()
class LeaderOverview extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    changePersonState: PropTypes.func.isRequired,
    orgContactDeletionTypes: PropTypes.array,
    deleteLeader: PropTypes.func.isRequired,
    sendRecoveryPassword: PropTypes.func.isRequired,
    permissions: PropTypes.object
  }

  static defaultProps = {
    codeLists: {
      personStates: {
        list: []
      }
    }
  }

  render() {
    const {
      data,
      orgContactDeletionTypes,
      codeLists,
      activeOrganization,
      permissions: appPermissions,
    } = this.props
    const role = getActiveRole(activeOrganization)

    const actions = [
      {
        id: 1,
        label: 'Change status',
        intlKey: 'label.change_leader_status',
        onClick: () => this.props.modal('contact-status-change')
      },
      {
        id: 2,
        label: 'Transfer participants',
        intlKey: 'label.transfer_participants',
        onClick: () => this.props.modal('transfer-participants-modal')
      },
      {
        id: 3,
        label: 'Send test email',
        intlKey: 'contact.send_test_email',
        onClick: () => this.props.modal('send-test-email'),
        roles: [ROLES.IF_STAFF_SUPER.u]
      },
      {
        id: 4,
        label: 'Recover password',
        intlKey: 'participant.recover_password',
        onClick: () => this.props.modal('contact-recover-password')
      },
      {
        id: 5,
        label: 'Delete account',
        intlKey: 'leader.delete_account',
        onClick: () => this.props.modal('delete-leader-account')
      }
    ]

    const actionsByRole = actions.filter(item => {
      if (item.roles) {
        return item.roles.some(
          actioRole => actioRole === role || actioRole === ROLES.ALL.u
        )
      }
      return item
    })

    return (
      <div>
        <Module
          primary
          grid
          title="Overview"
          intlKey="moduleTitle.overview"
          actionDropdown="Account Settings"
          actionDropdownActions={actionsByRole}
          intlKeyAction="button.account_settings"
          iconAction="settings"
        >
          <div className="row">
            <div className="col-xs-3">
              <FormData label="State" intlKey="label.state">
                <Status state={get(data, 'person.personState')} />
              </FormData>
            </div>
            {!appPermissions.isLeader && <div className="col-xs-3">
              <FormData label="ORB account" intlKey="label.orb_account">
                <ModuleLink
                      to={`${config.publicPath}/organizations/${get(data, 'organization.id')}/contacts/${get(data, 'id')}`}
                  text={<FormattedMessage id='label.other_roles' defaultMessage='See other roles' />} />
              </FormData>
            </div>}
          </div>
        </Module>
        <Modal id="transfer-participants-modal" customActions enableOverflow>
          <LeaderTransferParticipants
            decoOrganizationId={get(data, 'organization.id')}
          />
        </Modal>
        <Modal id="delete-leader-account" customActions enableOverflow>
          <ContactRemove
            id={data.id}
            onDelete={this.props.deleteLeader}
            reasonsList={orgContactDeletionTypes}
            contactRemoveType={REMOVE_CONTACT_TYPES.AWARD_LEADER.value}
          />
        </Modal>
        <Modal id="contact-status-change" compact customActions>
          <ContactSettings
            data={data.person}
            awardLeaderData={data}
            personStates={codeLists.personStates.list}
            changePersonState={this.props.changePersonState}
          />
        </Modal>
        <Modal id="send-test-email" customActions>
          <EmailSend
            onCancel={() => this.props.modal(null)}
            personId={get(data, 'person.id')}
          />
        </Modal>
        <Modal id="contact-recover-password" compact customActions>
          <div className="row">
            <div className="col-xs-12">
              <h2 className="text--center">
                <FormattedMessage
                  id="participant.send_password_recovery_email"
                  defaultMessage="Send password recovery email?"
                />
              </h2>
            </div>
            <div className="col-xs-6">
              <Button type="button" onClick={() => this.props.modal(null)} secondary>
                <FormattedMessage id="button.close" defaultMessage="Close" />
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                type="button"
                onClick={() =>
                  this.props.sendRecoveryPassword(
                    get(data, 'email') || get(data, 'person.email')
                  )}
              >
                <FormattedMessage
                  id="button.confirm"
                  defaultMessage="Confirm"
                />
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

/* onClick={() => this.props.modal('leader-account-settings')} */

/* <Modal
  id="leader-account-settings"
  compact
  action="Select"
  intlKeyAction="modal.select"
  customActions
>
  <LeaderSettings {...this.props} />
</Modal> */

// <div className="col-xs-3">
//   <FormData label="Activation date" intlKey="label.activation_date">
//     ---
//   </FormData>
// </div>
// <div className="col-xs-3">
//   <FormData
//     label="Active participants"
//     intlKey="label.active_participants"
//   >
//     ---
//   </FormData>
// </div>
// <div className="col-xs-3">
//   <FormData
//     label="Participants total"
//     intlKey="label.participants_total"
//   >
//     ---
//   </FormData>
// </div>

export default LeaderOverview
